import { render, staticRenderFns } from "./ChangeLogList.vue?vue&type=template&id=096d5bac&scoped=true&"
import script from "./ChangeLogList.vue?vue&type=script&lang=js&"
export * from "./ChangeLogList.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLogList.vue?vue&type=style&index=0&id=096d5bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d5bac",
  null
  
)

export default component.exports